module.exports = __webpack_public_path__ + "img/p2-1.8a58f285.png";